// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a.hospital-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  flex: 1;
  cursor: pointer;
}
a.hospital-link:hover {
  text-decoration: none;
}
a.hospital-link:visited {
  color: inherit;
}

ion-avatar {
  width: calc(60 * var(--width-ratio));
  height: calc(60 * var(--width-ratio));
}

.mybadge {
  position: absolute;
  top: 10px;
  left: calc(45 * var(--width-ratio));
}

.slot-content {
  flex: 1;
  padding-top: calc(16 * var(--width-ratio));
  padding-bottom: calc(16 * var(--width-ratio));
  margin-left: calc(12 * var(--width-ratio));
}
.slot-content .item-name {
  width: calc(160 * var(--width-ratio));
  height: calc(28 * var(--width-ratio));
}
.slot-content .item-address {
  width: calc(160 * var(--width-ratio));
  height: calc(16 * var(--width-ratio));
}

.slot-end {
  flex-basis: calc(108 * var(--width-ratio));
}
.slot-end .buttons-div {
  width: 100%;
  height: calc(46 * var(--width-ratio));
  background: rgba(162, 146, 193, 0.1);
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
}
.slot-end .buttons-div .mybutton {
  height: unset;
  margin: unset;
}
.slot-end .buttons-div .mybutton ion-icon {
  width: calc(24 * var(--width-ratio));
  height: calc(24 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/hospital-list-item/hospital-list-item.component.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;EACA,eAAA;AAAF;AAEE;EACE,qBAAA;AAAJ;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,oCAAA;EACA,qCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,SAAA;EACA,mCAAA;AAFF;;AAKA;EACE,OAAA;EACA,0CAAA;EACA,6CAAA;EACA,0CAAA;AAFF;AAIE;EACE,qCAAA;EACA,qCAAA;AAFJ;AAKE;EACE,qCAAA;EACA,qCAAA;AAHJ;;AAOA;EACE,0CAAA;AAJF;AAME;EACE,WAAA;EACA,qCAAA;EACA,oCAAA;EACA,4BAAA;EACA,+BAAA;AAJJ;AAMI;EACE,aAAA;EACA,aAAA;AAJN;AAWM;EACE,oCAAA;EACA,qCAAA;AATR","sourcesContent":["// SEO 優化：將主要區域包裝在 a 標籤內，移除預設樣式\na.hospital-link {\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n  flex: 1;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:visited {\n    color: inherit;\n  }\n}\n\nion-avatar {\n  width: calc(60 * var(--width-ratio));\n  height: calc(60 * var(--width-ratio));\n}\n\n.mybadge {\n  position: absolute;\n  top: 10px;\n  left: calc(45 * var(--width-ratio));\n}\n\n.slot-content {\n  flex: 1;\n  padding-top: calc(16 * var(--width-ratio));\n  padding-bottom: calc(16 * var(--width-ratio));\n  margin-left: calc(12 * var(--width-ratio));\n\n  .item-name {\n    width: calc(160 * var(--width-ratio));\n    height: calc(28 * var(--width-ratio));\n  }\n\n  .item-address {\n    width: calc(160 * var(--width-ratio));\n    height: calc(16 * var(--width-ratio));\n  }\n}\n\n.slot-end {\n  flex-basis: calc(108 * var(--width-ratio));\n\n  .buttons-div {\n    width: 100%;\n    height: calc(46 * var(--width-ratio));\n    background: rgba(162, 146, 193, 0.1);\n    border-top-left-radius: 40px;\n    border-bottom-left-radius: 40px;\n\n    .mybutton {\n      height: unset;\n      margin: unset;\n      // --padding-end: unset;\n      // --padding-start: unset;\n      // margin-left: 20px;\n\n      //background-color: yellow;\n\n      ion-icon {\n        width: calc(24 * var(--width-ratio));\n        height: calc(24 * var(--width-ratio));\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
